import { Routes, Route, Navigate, useLocation } from 'react-router-dom'
import Header from './components/Layout/Header'
import Footer from './components/Layout/Footer'
import HomePage from './pages/HomePage'
import PricingPage from './pages/PricingPage'
import FeaturesPage from './pages/FeaturesPage'
import ContactPage from './pages/ContactPage'
import LoginPage from './pages/LoginPage'
import PrivacyPage from './pages/PrivacyPage'
import TermsPage from './pages/TermsPage'
import SignupPage from './pages/SignupPage'
import OnboardingLayout from './onboarding/OnboardingLayout'
import OnboardingHome from './onboarding/pages/OnboardingHome'
import OnboardingWizard from './onboarding/pages/OnboardingWizard'

function App() {
  const location = useLocation()
  // The onboarding wizard is a focused, single-task flow - it gets its own
  // minimal chrome (see OnboardingLayout) instead of the marketing nav/footer.
  const isOnboarding = location.pathname.startsWith('/onboarding')

  return (
    <div className="app">
      {!isOnboarding && <Header />}
      <main className="main">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/features" element={<FeaturesPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/signup/*" element={<SignupPage />} />
          <Route path="/register" element={<Navigate to="/signup" replace />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/onboarding" element={<OnboardingLayout />}>
            <Route index element={<OnboardingHome />} />
            <Route path=":token" element={<OnboardingWizard />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
      {!isOnboarding && <Footer />}
    </div>
  )
}

export default App